export const EMPLOYEES = 'managerialTree@allEmployee';

export default {
    [EMPLOYEES]: {
        // url: 'employee/get/all'
        url: 'employee/get/all/preview'
    }
};
